import {useSelector} from "react-redux";
import {checkIfCurrentUserTurnInState} from "./checkIfCurrentUserTurnInState";

// «Ход пользователя» с учетом одновременной фазы снабжения сетевой игры: там
// ход у каждого игрока свой, пока он не закончил свою часть фазы (см.
// checkIfCurrentUserTurnInState)
export const useIsCurrentUserTurn = () => useSelector(checkIfCurrentUserTurnInState);
